import { ref as n } from "vue";
const t = n("");
function i(r) {
  t.value = r;
}
function f() {
  if (!t.value)
    throw new Error("Registry URL is not defined");
  return t.value;
}
const e = n("");
function u(r) {
  e.value = r;
}
function l() {
  if (!e.value)
    throw new Error("Platform ID is not defined");
  return e.value;
}
export {
  l as getPlatformId,
  f as getRegistryUrl,
  u as setPlatformId,
  i as setRegistryUrl
};
